import { Field } from 'formik';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCheckoutState } from '../../../utils/checkoutState';
import SubHeadline from '../../atoms/SubHeadline';
import OptionsField from '../../formik/OptionsField';
import AddressOverview from '../AddressOverview';
import { showDefaultError } from '../Notifications';
import BillingAddressForm, { BillingAddressFormProps } from './BillingAddressForm';
import './style.scss';

const BillingAddress = ({
  isCollectionPoint,
  isEditingBillingAddress,
  setEditingBillingAddress,
  setLoading,
}: { isCollectionPoint: boolean } & BillingAddressFormProps) => {
  const StoredBillingAddressForm = useCallback(
    () => (
      <BillingAddressForm
        isEditingBillingAddress={isEditingBillingAddress}
        setEditingBillingAddress={setEditingBillingAddress}
        setLoading={setLoading}
      />
    ),
    [isEditingBillingAddress]
  );
  const { setShippingAddressAsBillingAddress } = useCheckoutState();
  const { formatMessage } = useIntl();

  const options = [
    {
      key: 'sameAddress',
      label: formatMessage({ id: 'address.sameAddress' }),
    },
    {
      key: 'differentAddress',
      label: formatMessage({ id: 'address.differentAddress' }),
      form: StoredBillingAddressForm,
    },
  ];

  const onChange = async (value: string) => {
    if (value === 'sameAddress') {
      setLoading(true);
      try {
        await setShippingAddressAsBillingAddress();
        setEditingBillingAddress(false);
      } catch (e) {
        console.error(e);
        showDefaultError();
      }
      setLoading(false);
    } else if (value === 'differentAddress') {
      setEditingBillingAddress(true);
    }
  };

  return (
    <>
      {!isCollectionPoint && (
        <SubHeadline>
          <FormattedMessage id="address.billingAddress" />
        </SubHeadline>
      )}
      {!isCollectionPoint ? (
        <Field
          name="billingAddressType"
          component={OptionsField}
          options={options}
          isVertical
          dataTestIdPrefix="billingOptions"
          onChange={onChange}
        />
      ) : isEditingBillingAddress ? (
        <StoredBillingAddressForm />
      ) : (
        <AddressOverview addressType="billing" onChangeClick={() => setEditingBillingAddress(true)} showTitle />
      )}
    </>
  );
};

export default BillingAddress;
